<template>
  <component :is=resolveLayout>
    <transition name=fade mode=out-in>
      <router-view></router-view>
    </transition>
    <demo-banner></demo-banner>
    <vue-progress-bar></vue-progress-bar>
    <notifications position=bottom right />
  </component>
</template>

<script>
import { computed } from '@vue/composition-api';
import { useRouter } from '@/utils';
import LayoutBlank from '@/layouts/Blank.vue';
import DemoBanner from '@/components/DemoBanner.vue';
import LayoutAdmin from '@/layouts/LayoutAdmin.vue';
import LayoutSchool from '@/layouts/LayoutSchool.vue';
import LayoutDriver from '@/layouts/LayoutDriver.vue';
import LayoutParent from '@/layouts/LayoutParent.vue';
import LayoutStudent from '@/layouts/LayoutStudent.vue';

export default {
  components: {
    DemoBanner,
    LayoutBlank,
    LayoutAdmin,
    LayoutSchool,
    LayoutDriver,
    LayoutGuardian: LayoutParent,
    LayoutStudent,
  },
  setup() {
    const { route } = useRouter();

    const resolveLayout = computed(() => {
      if (route.value.name === null) return null;
      if (route.value.meta.layout === 'blank') return 'layout-blank';
      if (route.value.meta.layout === 'admin') return 'layout-admin';
      if (route.value.meta.layout === 'school') return 'layout-school';
      if (route.value.meta.layout === 'driver') return 'layout-driver';
      if (route.value.meta.layout === 'guardian') return 'layout-guardian';
      if (route.value.meta.layout === 'student') return 'layout-student';
      return 'layout-blank';
    });

    return { resolveLayout };
  },
  mounted() {
    this.$Progress.finish();
  },
  created() {
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        this.$Progress.parseMeta(to.meta.progress);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
    });
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
